<template>
  <div style="width: 100%; height: 84vh; display: flex;justify-content: space-between;">
    <div class="left-part">
      <div class="left-top item" style="height:40vh">
        <div class="currency_title">
          <div class="left">
            <img src="@/assets/img/cooperation/hzsl@2x.png" />
            <span>合作社数量</span>
          </div>
          <div class="right"></div>
        </div>
        <div class="block_model">
          <left-top-chart height="35vh" :chartData="rightBottomData" id="plantRightTop"></left-top-chart>
          <div class="page_btns">
            <div class="page pre"></div>
            <div class="page next active"></div>
          </div>
        </div>
      </div>
      <div class="left-bottom item" style="height:45vh">
        <div class="currency_title">
          <div class="left">
            <img src="@/assets/img/cooperation/bhqk@2x.png" />
            <span>历年合作社数量变化情况</span>
          </div>
          <div class="right"></div>
        </div>
        <div class="block_model">
          <left-bottom-chart height="42vh" :chartData="[]"></left-bottom-chart>
          <!--  <bar id="estateBar" :chartData="rightBottomData"></bar> -->
        </div>
      </div>
    </div>
    <!--左边-->
    <div class="center-part">
      <!--左上-->

      <!--左下-->
      <div class="cityMap" style="height: 69vh; margin-top: 1.5vh">
        <cityMap
          style="float: right"
          :geoPath="geoPath"
          id="home_map_"
          ref="homeMap"
          width="80%"
          height="99%"
        ></cityMap>
      </div>
    </div>

    <!--右边-->
    <div class="right-part" style="margin-left: 0.75vw">
      <!--右上-->
      <div class="right_item item" style="height: 40vh">
        <div class="currency_title">
          <div class="left">
            <img src="@/assets/img/cooperation/rwwc@2x.png" />
            <span>合作社作业任务完成量排行</span>
          </div>
          <div class="right"></div>
        </div>
        <div class="info_exhibition">
          <div class="title">
            <div style="width:15%">名次</div>
            <div style="width:30%">合作社</div>
            <div style="width:50%">累计完成任务数</div>
          </div>
          <div class="body">
            <vue-seamless-scroll
              :data="rightTableData"
              class="seamless-warp top-scroll"
              :class-option="classOption"
            >
              <ul class="info_item_list">
                <li class="info_item" v-for="(item, index) in rightTableData" :key="index">
                  <div class="center-center" style="width:15%">
                    <div class="index">{{ index + 1 }}</div>
                  </div>
                  <div class="name" style="width:30%">{{ item.companyName }}</div>
                  <div class="pro-bar">
                    <div class="val" :style="{ width: item.percent + '%' }"></div>
                  </div>
                  <div>{{ item.value }}</div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>

      <!--右下-->
      <div class="right_item item" style="height: 47vh;">
        <div class="currency_title">
          <div class="left">
            <img src="@/assets/img/cooperation/hzgm@2x.png" />
            <span>合作社规模情况</span>
          </div>
          <div class="right"></div>
        </div>
        <div class="block_model">
          <bar id="estateBar" height="45vh" :chartData="rightBottomData"></bar>
        </div>
      </div>
      <div
        class="dialog_list"
        v-show="dialog && !$panel.stack.length && !test"
        id="dragDiv"
        :style="{ left: dialogLeft, top: dialogTop }"
        @mouseover="dialogMouseIn"
        @mouseout="dialogMouseOut"
      >
        <div class="dialogName">
          <!-- <img src="@/assets/img/estate_scale/land.png" alt /> -->
          {{ landName }}
        </div>
        <div class="dialog_list_title">
          <span class="close" @click="closeDialog">X</span>
        </div>
        <div class="dialog_list_item">
          <div class="title">
            <span class="name">地块数量</span>
            <span class="count">{{ landList.length || 0 }}家</span>
          </div>
          <div class="item_content_body">
            <div
              class="item_content_li"
              @click="getLandInfo(item)"
              v-for="(item, index) in landList"
              :key="index"
            >{{ item.areaName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cityMap from "../Home/components/homeMap";
import lineChart from "./components/rightCenter";
import bar from "./components/rightBottom";

import LeftTopChart from "./components/left_top_chart";
import LeftBottomChart from "./components/left_bottom_chart";
export default {
  components: {
    cityMap,
    lineChart,
    bar,
    LeftTopChart,
    LeftBottomChart,
  },
  data() {
    return {
      dialogSign: false,
      dialog: false,
      selectType: 0,
      landInfo: {},
      test: false,
      dialogLeft: "50px",
      dialogTop: "50px",
      optionList: [], // 地图下拉option
      totalData: {},
      areaList: [],
      landList: [], // 地块列表数据
      rightCenterData: [],
      rightTopTableData: [],
      rightBottomData: [],
      rightTableData: [
        {
          companyName: "河南省",
          companyTypeName: "869503039739076",
          scale: "河南省洛阳市洛龙区李村镇",
          value: 234,
        },
        {
          companyName: "河南省",
          companyTypeName: "869503039739076",
          scale: "河南省洛阳市洛龙区李村镇",
          value: 234,
        },
        {
          companyName: "河南省",
          companyTypeName: "869503039739076",
          scale: "河南省洛阳市洛龙区李村镇",
          value: 234,
        },
        {
          companyName: "河南省",
          companyTypeName: "869503039739076",
          scale: "河南省洛阳市洛龙区李村镇",
          value: 234,
        },
        {
          companyName: "河南省",
          companyTypeName: "869503039739076",
          scale: "河南省洛阳市洛龙区李村镇",
          value: 234,
        },
        {
          companyName: "河南省",
          companyTypeName: "869503039739076",
          scale: "河南省洛阳市洛龙区李村镇",
          value: 234,
        },
        {
          companyName: "河南省",
          companyTypeName: "869503039739076",
          scale: "河南省洛阳市洛龙区李村镇",
          value: 234,
        },
      ],
      areaData: [],
      landList: [],
      landName: "",
      isMove: false,
      geoPath: "/js/henan.json",
    };
  },
  name: "EstateScale",
  mounted() {
    //this.dragDivInit();
  },
  beforeDestroy() {
    this.isMove = false;
  },
  computed: {
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    selectChange() {
      this.initChartData();
    },
    dialogMouseIn() {
      if (this.dialog) {
        this.dialogSign = true;
      }
    },
    dialogMouseOut() {
      if (this.dialog) {
        this.dialogSign = false;
      }
    },
    // 监听指针是否超出地图边界
    globalout() {
      setTimeout(() => {
        if (this.dialog) {
          if (!this.dialogSign) {
            this.dialog = false;
          } else {
            this.dialog = true;
          }
        }
      }, 50);
    },
    backMap() {
      this.initChartData();
      this.$store.dispatch("setActiveRegionName", "柯城区");
      this.$refs.estateMap.initChart(true);
    },
    dragDivInit() {
      const that = this;
      document.onmousemove = function (event) {
        var Drag = document.getElementById("dragDiv");
        Drag.onmousedown = function (event) {
          var ev = event || window.event;
          event.stopPropagation();
          var disX = ev.clientX - Drag.offsetLeft;
          var disY = ev.clientY - Drag.offsetTop;
          document.onmousemove = function (event) {
            that.isMove = true;
            var ev = event || window.event;
            Drag.style.left = ev.clientX - disX + "px";
            Drag.style.top = ev.clientY - disY + "px";
            Drag.style.cursor = "move";
          };
        };
        Drag.onmouseup = function () {
          document.onmousemove = null;
          this.style.cursor = "default";
        };
      };
    },
    closeDialog() {
      this.dialog = false;
    },
    getLandInfo(item) {
      this.landInfo = item;
      this.test = true;
      this.dialog = false;
    },
    initChartData(regionName = "柯城区") {
      this.closeDialog();
      this.getAreaProductionList(regionName);
      this.getPlantAreaList(regionName);
      this.getPlantAreaByRegionID(regionName);
      this.getAreaProductionListByRegionID(regionName);
      this.getDicPz(regionName);
      this.getDashboardAreaProductionList(regionName);
    },
    // 地图上的数据
    getAreaProductionList(regionName = "柯城区") {
      // 默认取柯城区数据，柯城区区域ID regionId: 330802000000
      estateApi
        .getAreaProductionList({
          regionName: regionName,
          cropsId: this.selectType ? this.selectType : null,
        })
        .then((res) => {
          this.totalData = res.list.totalData;
          this.areaData = res.list.allAreaData;
        });
    },
    // 右-上table数据
    getPlantAreaList(regionName = "柯城区") {
      estateApi
        .getPlantAreaList({
          regionName: regionName,
          cropsId: this.selectType ? this.selectType : null,
        })
        .then((res) => {
          this.rightTopTableData = res.list;
        });
    },
    // 获取地块数据
    getSoilData(areaId) {
      this.$panel.open(
        summary,
        {
          landInfo: this.landInfo,
          areaId: this.landInfo.areaId,
        },
        {
          width: 640,
          height: 400,
          top: "center",
          left: "center",
          name: "estateDialog",
        }
      );
    },
    // 获取地图上的地块
    getDashboardAreaProductionList() {
      estateApi
        .getDashboardAreaProductionList({ pageNo: 1, pageSize: 999999 })
        .then((res) => {
          let list = res.page.list;
          list.forEach((el) => {
            el["name"] = el["regionName"];
            el["value"] = [el.longitude, el.latitude];
          });
          this.landList = list;
        });
    },
    // 右-下 图表数据
    getAreaProductionListByRegionID(regionName = "柯城区") {
      this.rightBottomData = {
        regionName: [],
        actualProduction: [],
      };
      estateApi
        .getAreaProductionListByRegionID({
          regionName: regionName,
          cropsId: this.selectType ? this.selectType : null,
        })
        .then((res) => {
          let list = res.list;
          list.forEach((el) => {
            this.rightBottomData.regionName.push(el.regionName);
            this.rightBottomData.actualProduction.push(el.actualProduction);
            el["name"] = el["regionName"];
            el["value"] = el["actualProduction"];
          });
          this.areaList = list;
        });
    },
    // 右-中 图表数据
    getPlantAreaByRegionID(regionName = "柯城区") {
      this.rightCenterData = {
        regionName: [],
        actualArea: [],
        plantArea: [],
      };
      estateApi
        .getPlantAreaByRegionID({
          regionName: regionName,
          cropsId: this.selectType ? this.selectType : null,
        })
        .then((res) => {
          let list = res.list;
          list.forEach((el) => {
            this.rightCenterData.regionName.push(el.regionName);
            this.rightCenterData.actualArea.push(el.plantArea);
            this.rightCenterData.plantArea.push(parseInt(el.actualArea));
          });
        });
    },
    // 获取种植品种
    getDicPz() {
      estateApi.getDicPz().then((res) => {
        this.optionList = res.list;
      });
    },
    getAreaTempListByRegion(regionName) {
      estateApi
        .getAreaTempListByRegion({
          regionName: regionName,
          cropsId: this.selectType == 0 ? undefined : this.selectType,
        })
        .then((res) => {
          this.landName = regionName;
          this.landList = res.list;
        });
    },
    mapOver(data) {
      if (!this.isMove) {
        this.dialogLeft = data.event.offsetX + 25 + "px";
        this.dialogTop = data.event.offsetY + 100 + "px";
      }
      if (!this.test) {
        this.dialog = true;
      }
      this.getAreaTempListByRegion(data.name);
    },
    mapOut(param) {
      if (!param.value) {
        // this.test = false;
      }
    },
    openInfo() {
      if (this.$panel.stack.length) {
        this.$panel.closeAll();
      }
      if (this.test) {
        this.test = false;
      }
      this.getSoilData(this.landInfo.areaId);
    },
    openVideo() {
      if (this.$panel.stack.length) {
        this.$panel.closeAll();
      }
      this.$panel.open(
        videoPane,
        {},
        { width: 640, height: 536, top: "center", left: "center" }
      );
    },
    mapClick(data) {
      this.$store.dispatch("setActiveRegionName", data.name);
      this.initChartData(data.name);
    },
  },
  created() {
    this.$store.dispatch("setActiveRegionName", "柯城区");
    this.initChartData();
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.item {
  padding: 1.5vh 0;
}
.center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-part,
.right-part {
  width: vw(417);
  box-sizing: border-box;
}
.left-part {
  padding-left: vw(20);
}
.right-part {
  padding-right: vw(20);
}
.center-part {
  width: vw(998);
}
.pro-bar {
  width: vw(154) !important;
  height: vh(12);
  background: rgba(3, 160, 134, 0.15);
  position: relative;
  .val {
    position: absolute;
    left: 0;
    top: 0;
    height: vh(12);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 154, 0.15) 0%,
      #0dfca7 100%
    );
  }
}
.page_btns {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: -20px;
  .page {
    width: vw(12);
    height: vh(18);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #62d9ad;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
  }
  .page.active {
    color: #fff;
  }
  .page.pre {
    background-image: url("../../assets/img/common/pre-default.png");
  }
  .page.next {
    background-image: url("../../assets/img/common/next-default.png");
  }
  .page.pre.active {
    background-image: url("../../assets/img/common/pre-active.png");
  }
  .page.next.active {
    background-image: url("../../assets/img/common/next-active.png");
  }
}
.top-scroll {
  height: 100% !important;
}
.top-scroll .index {
  width: vw(24) !important;
  height: vh(24);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #08ffce;
  border-radius: 4px;
}
.top-scroll .info_item:nth-child(1) .index {
  border-color: #ffff9a;
}
.top-scroll .info_item:nth-child(2) .index {
  border-color: #55db42;
}
.top-scroll .info_item:nth-child(3) .index {
  border-color: #3ecdff;
}
.top-scroll .info_item:nth-child(1) .val {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 154, 0.15) 0%,
    #f8fa98 100%
  );
}
.top-scroll .info_item:nth-child(2) .val {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 154, 0.15) 0%,
    #52d541 100%
  );
}
.top-scroll .info_item:nth-child(3) .val {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 154, 0.15) 0%,
    #3cc9f8 100%
  );
}
.top-scroll .name {
  width: 30% !important;
}
/* .top-scroll .pro-bar {
  width: 40% !important;
} */
::v-deep.seamless-warp {
  width: 100%;
  height: calc(100% - 30px);
  overflow: hidden;
}
.back_button {
  z-index: 9999;
  position: absolute;
  top: vh(25);
  right: 20px;
  img {
    width: vw(40);
    cursor: pointer;
  }
}
.dialog_list {
  z-index: 10000;
  width: vw(300);
  height: auto;
  border: 1px solid #4498e0;
  box-shadow: 0px 0px 8px 2px rgba(51, 159, 251, 0.3);
  background: RGBA(10, 30, 56, 0.92);
  border-radius: 2px;
  position: absolute;
  top: vh(400);
  right: vw(200);
  color: RGBA(8, 188, 165, 1);
  padding: vh(20);
  font-size: vh(12);
  .dialogName {
    width: 50%;
    float: left;
    font-size: vh(24);
    img {
      height: vh(22);
      line-height: vh(18);
    }
  }
  .dialog_list_item {
    clear: both;
  }
  .dialog_list_title {
    width: 40%;
    float: right;
    text-align: right;
    font-size: vh(20);
  }
  .close {
    cursor: pointer;
  }
  .title {
    line-height: vh(60);
    .name {
      padding: vw(5);
      background: #08ffce;
      color: #092147;
      border-radius: 2px;
      font-weight: bolder;
    }
    .count {
      font-size: vh(14);
      color: #08ffce;
      margin-left: vw(9);
      line-height: vh(20);
    }
  }
  .item_content_li {
    color: #ffffff;
    font-size: vh(12);
    line-height: vh(40);
    cursor: pointer;
    &:hover {
      color: #08ffce;
    }
  }
}
.dialog_efect {
  z-index: 1000;
  width: vw(400);
  height: auto;
  border: 1px solid #1a72af;
  background: RGBA(10, 30, 56, 0.9);
  position: absolute;
  top: vw(147);
  left: vh(494);
  color: RGBA(8, 188, 165, 1);
  padding: vw(10) vh(10);
  .title {
    font-size: vh(18);
    font-weight: bolder;
    img {
      height: vh(22);
      line-height: vh(18);
    }
    span {
      position: absolute;
      color: #1a72af;
      right: 6px;
      cursor: pointer;
    }
  }
  table {
    width: 100%;
    line-height: vh(40);
    font-size: vh(14);
    th {
      width: 40%;
      color: #ffffff;
      text-align: right;
      padding: vw(10) vh(10);
    }
    td {
      width: 60%;
      text-align: left;
      padding: vw(10) vh(10);
    }
  }
  .efect_footer {
    table {
      width: 100%;
      line-height: vh(40);
      font-size: vh(14);
      color: #339ffb;
      td:nth-child(1) {
        width: 30%;
        text-align: right;
      }
      td {
        padding: vw(10) vh(10);
      }
    }
    a {
      cursor: pointer;
    }
  }
}
.left_item {
  width: 15.75vw;
  /*  background-image: url("../../assets/img/estate_scale/chanye_kuang.png"); */
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    color: #ffffff;
    font-size: 1.7vh;
  }
  .num {
    color: #08ffce;
    font-weight: 600;
    font-size: 3.5vh;
    margin-top: 2.5vh;
  }
}

.left_bottom {
  border: 1px solid #4498e0;
  box-shadow: 0px 0px 10px 7px rgba(51, 159, 251, 0.3) inset;
}
.info_exhibition {
  // flex: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .title {
    padding: 8px;
    display: flex;
    height: vh(50);
    color: #0dffa9;
    font-size: 1vh;
    align-items: center;
    div {
      width: 40%;
      text-align: center;
    }
  }
  .body {
    overflow: hidden;
  }
  .info_item {
    flex: 1;
    display: flex;
    color: rgba(255, 255, 255, 0.5);
    font-size: 1vh;
    align-items: center;
    padding: 8px;
    div {
      width: 20%;
      text-align: center;
    }
  }
  /*   .info_item:nth-child(even) {
    background-color: rgba(8, 255, 206, 0.12);
  } */
  .info_item:nth-child(even) {
    background: url("../../assets/img/home/scoll-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
  }
}
.right_item {
  position: relative;

  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  padding: 1.5vh 0vw;
}
</style>
